exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Step-module__step___g2OgO{border-radius:15px;overflow:hidden;display:flex;cursor:pointer}.Step-module__step___g2OgO .Step-module__left___31g_d{background-color:#1368e5;color:#fff;padding:10px;display:flex;flex-direction:column;font-weight:600}.Step-module__step___g2OgO .Step-module__left___31g_d,.Step-module__step___g2OgO .Step-module__right___2t6Ld{justify-content:center;align-items:center}.Step-module__step___g2OgO .Step-module__right___2t6Ld{background-color:#fff;width:200px;background-color:#bdccd4;display:grid}", ""]);

// exports
exports.locals = {
	"step": "Step-module__step___g2OgO",
	"left": "Step-module__left___31g_d",
	"right": "Step-module__right___2t6Ld"
};